/// <reference path="../../app.definition.ts" />
import { Serializable } from "./Serializable";

export class CareDetail implements Serializable<CareDetail> {
    id: number;
    detail: string;
    addedBy: number;

    deserialize(input: any) {
        input.id && (this.id = input.id);
        input.detail && (this.detail = input.detail);
        input.addedBy && (this.addedBy = input.addedBy);

        return this;
    }

    constructor() {
    }
}
